import { normalizeExplorerPath } from '@/lib/explorer-tree-focus'
import type { Space } from '@/hooks/use-spaces'

export type WorkspaceDocumentsRootInput = {
  id: string
  name: string
  contentRoot?: string | null
}

/** Documents tree entry path for a workspace (contentRoot + first space), same as sidebar Documents click. */
export function documentsRootPathForWorkspace(
  workspace: Pick<WorkspaceDocumentsRootInput, 'contentRoot'>,
  spaces: Pick<Space, 'path'>[] = [],
): string {
  if (!workspace.contentRoot?.trim()) return ''
  const first = spaces[0]
  return normalizeExplorerPath(
    (workspace.contentRoot ?? '').replace(/\/$/, '') +
      (first?.path ? '/' + String(first.path).replace(/\/$/, '') : ''),
  )
}
